<div class="register-section">
  <div class="f1-icon f1-sense-time-logo"></div>
  <div class="title">SenseHub</div>
  <div class="content">
    <span *ngIf="isError">Your invitation has expired.<br/>Please contact the farm for a new invitation</span>
    <span *ngIf="isLoading">Loading, please wait...</span>
  </div>
</div>
